import { NetInfoStateType, useNetInfo } from '@react-native-community/netinfo';

import {
    ConnectionIndicatorCellular,
    ConnectionIndicatorWifi,
} from 'assets/images';

const testIDs = {
    PLAYER_WIFI_ICON: 'PLAYER_WIFI_ICON',
    PLAYER_MOBILE_DATA_ICON: 'PLAYER_MOBILE_DATA_ICON',
};

export const ConnectionIndicator = () => {
    const { type } = useNetInfo();

    if (type === NetInfoStateType.wifi) {
        return <ConnectionIndicatorWifi testID={testIDs.PLAYER_WIFI_ICON} />;
    }

    if (type === NetInfoStateType.cellular) {
        return (
            <ConnectionIndicatorCellular
                testID={testIDs.PLAYER_MOBILE_DATA_ICON}
            />
        );
    }

    return null;
};
